(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof window.Lenis === 'undefined') return;

  var SQUEEZE_QUERY = window.matchMedia('(min-width: 990px)');
  var lenis = null;

  function getWrapper() {
    if (SQUEEZE_QUERY.matches) {
      var el = document.querySelector('.page-wrapper');
      if (el) return el;
    }
    return window;
  }

  function init() {
    var wrapper = getWrapper();
    var content = wrapper === window ? document.documentElement : wrapper.firstElementChild;
    if (!content) return;

    lenis = new window.Lenis({
      wrapper: wrapper,
      content: content,
      duration: 1.05,
      wheelMultiplier: 1,
      touchMultiplier: 1.2,
      smoothWheel: true,
      syncTouch: false,
      autoRaf: true,
    });

    window.zdLenis = lenis;
  }

  function reinit() {
    if (lenis) {
      lenis.destroy();
      lenis = null;
    }
    init();
  }

  init();
  SQUEEZE_QUERY.addEventListener('change', reinit);
})();
